import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "search-container",
  class: "p-input-icon-left p-m-2"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = { class: "kn-truncated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm kn-table bml-table kn-flex",
    value: _ctx.tableData,
    selection: _ctx.selectedRow,
    "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedRow = $event)),
    selectionMode: "single",
    dataKey: "id",
    responsiveLayout: "scroll",
    filters: _ctx.filters,
    "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
    globalFilterFields: _ctx.filterFields,
    paginator: true,
    rows: 25,
    loading: _ctx.loading,
    paginatorTemplate: "PrevPageLink PageLinks NextPageLink",
    stripedRows: "",
    metaKeySelection: false,
    onRowSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('rowSelected', $event, _ctx.dataType))),
    onRowUnselect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('rowUnselected', $event, _ctx.dataType)))
  }, {
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.headerTitle), 1)
        ]),
        _: 1
      }),
      _createVNode("span", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_InputText, {
          class: "kn-material-input",
          modelValue: _ctx.filters['global'].value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
          type: "text",
          placeholder: _ctx.$t('common.search'),
          "data-test": "filterInput"
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          field: col.field,
          header: _ctx.$t(col.header),
          key: col.field,
          sortable: true,
          headerStyle: _ctx.descriptor.style.uppercase
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(slotProps.data[col.field]), 1)
            ], 512), [
              [
                _directive_tooltip,
                slotProps.data[col.field],
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 2
        }, 1032, ["field", "header", "headerStyle"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "selection", "filters", "globalFilterFields", "loading"]))
}